import { z } from "zod";

// To-dos: the office's small follow-ups ("call KB about Lot 12", "order the
// 18x8 panel"), each for someone, optionally due, optionally about a job,
// customer or project. Team-visible; the people on it can tick it off.

export const TodoSchema = z.object({
  title: z.string().trim().min(1).max(300),
  note: z.string().max(2000).default(""),
  dueAt: z.number().nullable().default(null),
  assignedUid: z.string(),
  assignedName: z.string().default(""),
  createdByUid: z.string(),
  createdByName: z.string().default(""),
  createdAt: z.number(),
  done: z.boolean().default(false),
  doneAt: z.number().nullable().default(null),
  /** What it's about (opens from the to-do). */
  link: z
    .object({ kind: z.enum(["job", "customer", "project"]), id: z.string(), label: z.string().max(200) })
    .nullable()
    .default(null),
});
export type Todo = z.infer<typeof TodoSchema>;

// Project files: contracts, plans, elevations, kept on the project.
export const PROJECT_FILE_KINDS = ["contract", "plans", "elevations", "estimate", "photo", "other"] as const;
export const PROJECT_FILE_LABEL: Record<(typeof PROJECT_FILE_KINDS)[number], string> = {
  contract: "Contract",
  plans: "Plans",
  elevations: "Elevations",
  estimate: "Bid / estimate",
  photo: "Photo",
  other: "Other",
};
export const ProjectFileSchema = z.object({
  name: z.string().min(1).max(200),
  kind: z.enum(PROJECT_FILE_KINDS).default("other"),
  storagePath: z.string().max(500),
  size: z.number().int().min(0),
  contentType: z.string().max(120).default(""),
  uploadedByUid: z.string(),
  uploadedByName: z.string().default(""),
  createdAt: z.number(),
});
export type ProjectFile = z.infer<typeof ProjectFileSchema>;

// Calendar subscribe links: a secret URL a calendar app polls for jobs.
export const CALENDAR_SCOPES = ["mine", "all"] as const;
export const CalendarScopeSchema = z.union([z.enum(CALENDAR_SCOPES), z.string().regex(/^dept:[A-Za-z0-9_-]{1,64}$/)]);
export type CalendarScope = z.infer<typeof CalendarScopeSchema>;
